export default () => {
  return {
    ux: {
      activityTitle: null,
      activityType: null,
      reminderType: null,
      isPreviewMode: null
    }
  }
}